import { render, staticRenderFns } from "./TheMarriageApplicationForm.vue?vue&type=template&id=0f5f932c&scoped=true&"
import script from "./TheMarriageApplicationForm.vue?vue&type=script&lang=js&"
export * from "./TheMarriageApplicationForm.vue?vue&type=script&lang=js&"
import style0 from "./TheMarriageApplicationForm.vue?vue&type=style&index=0&id=0f5f932c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5f932c",
  null
  
)

export default component.exports